import axios from 'axios';
import { XGAC_MAIN_API_URL } from '../config';

export const xgacRequest = axios.create({
  baseURL: XGAC_MAIN_API_URL,
  validateStatus: (status) => status < 400,
});
